import { createFileRoute } from '@tanstack/react-router'
import { PolicyGapAnalysisPage } from '@/features/compliance-gap-analysis'
import { requireActiveSubscription } from '@/lib/middleware'

// Phase 2g (issue #309), Task 3. Gated the same way the neighbouring
// compliance routes are (standards.tsx, findings.tsx, policies.tsx, risks.tsx
// all call the same `requireActiveSubscription()` with no args) — the
// specific `compliance.policy_gap_analysis` entitlement is read inside the
// page component via `FeatureGate`/`useHasFeature`, never branched on a plan
// name (see index.tsx).
export const Route = createFileRoute('/_authenticated/_organization/compliance/gap-analysis')({
  beforeLoad: async () => requireActiveSubscription(),
  component: PolicyGapAnalysisPage,
})
